export default [
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/DictionaryList.vue'),
    meta: {},
  },
  // Chương
  {
    path: '/dictionary/dictionarychapter',
    name: 'dictionarychapter',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/dictionaryChapter/DictionaryChapterList.vue'),
    meta: {},
  },

  {
    path: '/dictionary/dictionaryExpenseOther',
    name: 'dictionaryexpenseother',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/dictionaryExpenseOther/DictionaryExpenseOtherList.vue'),
    meta: {},
  },
];
